import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import { Icons, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@curves/ui-base";
import { isEqual } from "@util/utils";

const MoreLabelBox = props => {
	const {
		refresh: refreshProps,
		moreLabelMap,
		moreActionArray = [],
		className,
		peopleID = "",
		type: typeProps,
		urls: urlProps,
		textAlign,
		buttonProps,
		sourceData: sourceDataProps,
		...others
	} = props;

	const [anchorEl, setAnchorEl] = useState(null);
	const [dialogOpen, setDialogOpen] = useState(null);
	const open = Boolean(anchorEl);

	const handleMoreIconClick = e => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = target => {
		if (target) setDialogOpen(target);
		setAnchorEl(null);
	};

	const handleDialogClose = e => {
		setDialogOpen(null);
		setAnchorEl(null);
	};

	return (
		<React.Fragment>
			<IconButton {...buttonProps} onClick={handleMoreIconClick}>
				<Icons.MoreVertical />
			</IconButton>
			{moreActionArray.length > 0 && (
				<React.Fragment>
					<Menu className={clsx("more-label-box-menu", Boolean(textAlign) && `align-${textAlign}`)} anchorEl={anchorEl} open={open} onClose={e => handleClose(null)}>
						{moreActionArray.map(target => {
							if (!moreLabelMap[target]) return null;
							const { text, icon, to, dialogString, onClickEvent, Dialog } = moreLabelMap[target];
							let menuProperty = {};
							if (to) {
								menuProperty.to = to({ urls: urlProps });
								menuProperty.component = NavLink;
							} else if (onClickEvent) {
								menuProperty.onClick = e => {
									handleClose(null);
									onClickEvent && onClickEvent(e);
								};
							} else if (Dialog) {
								menuProperty.onClick = e => handleClose(dialogString);
							}
							return (
								<MenuItem {...menuProperty} key={`more_label_${text}`}>
									{icon && <ListItemIcon>{icon}</ListItemIcon>}
									<ListItemText>{text}</ListItemText>
								</MenuItem>
							);
						})}
					</Menu>
					{moreActionArray.map((target, _index) => {
						if (!moreLabelMap[target]) return null;
						const { dialogString, Dialog } = moreLabelMap[target];
						const sourceData = isEqual(dialogOpen, dialogString) ? [{ ...sourceDataProps }] : [];
						return (
							<React.Fragment key={`more_dailog_${_index}`}>
								{!!Dialog && (
									<Dialog
										refresh={refreshProps}
										open={isEqual(dialogOpen, dialogString)}
										onClose={handleDialogClose}
										sourceData={sourceData}
										type={typeProps}
										peopleID={peopleID}
										{...others}
									/>
								)}
							</React.Fragment>
						);
					})}
				</React.Fragment>
			)}
		</React.Fragment>
	);
};

export default MoreLabelBox;
